// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/rocket-cloud.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#wizard #canvas, #wizard #rocket {
  pointer-events: none;
}

#wizard #rocket {
  position: absolute;
}

#wizard .discovery {
  padding-bottom: var(--base-sizes-6);
  text-align: center;
  position: relative;
}

#wizard #canvas, #wizard .discovery {
  transition: opacity 3s;
}

#wizard #canvas.show {
  opacity: 1;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--semantic-colors-surface-brand) / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 0 100%;
  background-repeat: repeat-x;
  transform: translateY(0);
}

#wizard .old-discovery-settings #canvas.show {
  background-color: #6c7e9d;
}

#wizard #canvas.fade, #wizard .fade, #wizard #rocket {
  opacity: 0;
}

#wizard #rocket.show {
  opacity: 1;
}

#wizard .btn-start, #wizard .btn-rounded {
  border-radius: 20px;
  display: inline-block;
}

#wizard .btn-start {
  border-radius: 40px;
  height: 40px;
  padding: 0 40px;
  line-height: 40px;
}

@media screen and (height <= 800px) {
  #wizard .go {
    height: 40px;
    line-height: 40px;
  }
}

@media screen and (height <= 768px) {
  #wizard #rocket svg {
    max-width: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/styles/rocket.css","webpack://./services/frontend/app/features/DiscoverySettingsForms/composition/DiscoveryConfigWizard/styles/rocket.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kFAAkF;EAClF,yDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["#wizard #canvas,\n  #wizard #rocket {\n    pointer-events: none;\n  }\n  #wizard #rocket {\n    position: absolute;\n  }\n  #wizard .discovery {\n    padding-bottom: var(--base-sizes-6);\n\n    position: relative;\n    text-align: center;\n}\n  #wizard #canvas,\n  #wizard .discovery {\n    transition: opacity 3s ease;\n  }\n  #wizard #canvas.show {\n    opacity: 1;\n    --tw-bg-opacity: 1;\n    background-color: rgb(var(--semantic-colors-surface-brand) / var(--tw-bg-opacity));\n\n    background-image: url('public/img/rocket-cloud.png');\n    background-position: left bottom;\n    background-repeat: repeat-x;\n    transform: translateY(0);\n  }\n  #wizard .old-discovery-settings #canvas.show {\n    background-color: #6c7e9d;\n  }\n  #wizard #canvas.fade,\n  #wizard .fade,\n  #wizard #rocket {\n    opacity: 0;\n  }\n  #wizard #rocket.show {\n    opacity: 1;\n  }\n  #wizard .btn-start,\n  #wizard .btn-rounded {\n    border-radius: 20px;\n    display: inline-block;\n  }\n  #wizard .btn-start {\n    border-radius: 40px;\n    height: 40px;\n    padding: 0 40px;\n    line-height: 40px;\n  }\n  @media screen and (max-height: 800px) {\n    #wizard .go {\n      height: 40px;\n      line-height: 40px;\n    }\n  }\n  @media screen and (max-height: 768px) {\n    #wizard #rocket svg {\n      max-width: 80px;\n    }\n  }\n","#wizard #canvas, #wizard #rocket {\n  pointer-events: none;\n}\n\n#wizard #rocket {\n  position: absolute;\n}\n\n#wizard .discovery {\n  padding-bottom: var(--base-sizes-6);\n  text-align: center;\n  position: relative;\n}\n\n#wizard #canvas, #wizard .discovery {\n  transition: opacity 3s;\n}\n\n#wizard #canvas.show {\n  opacity: 1;\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--semantic-colors-surface-brand) / var(--tw-bg-opacity));\n  background-image: url(\"public/img/rocket-cloud.png\");\n  background-position: 0 100%;\n  background-repeat: repeat-x;\n  transform: translateY(0);\n}\n\n#wizard .old-discovery-settings #canvas.show {\n  background-color: #6c7e9d;\n}\n\n#wizard #canvas.fade, #wizard .fade, #wizard #rocket {\n  opacity: 0;\n}\n\n#wizard #rocket.show {\n  opacity: 1;\n}\n\n#wizard .btn-start, #wizard .btn-rounded {\n  border-radius: 20px;\n  display: inline-block;\n}\n\n#wizard .btn-start {\n  border-radius: 40px;\n  height: 40px;\n  padding: 0 40px;\n  line-height: 40px;\n}\n\n@media screen and (height <= 800px) {\n  #wizard .go {\n    height: 40px;\n    line-height: 40px;\n  }\n}\n\n@media screen and (height <= 768px) {\n  #wizard #rocket svg {\n    max-width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
